import React from "react";
import {CJLogin} from "../cjauth";
import {authConfig} from "../utils/authConfig";

export const Login = () => {
  return <CJLogin authConfig={ authConfig() } />
}
